export { default as getRouteComponents } from './getRouteComponents';
export { default as hasLanguage } from './hasLanguage';
